import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './AuthContext'
import Nav from './components/Nav'
import Inicio from './pages/Inicio'
import Login from './pages/Login'
import Reservas from './pages/Reservas'
import Admin from './pages/Admin'
import AdminCarta from './pages/AdminCarta'
import AdminEncuestas from './pages/AdminEncuestas'
import AdminAjustes from './pages/AdminAjustes'
import Carta from './pages/Carta'
import Alergenos from './pages/Alergenos'
import Privacidad from './pages/Privacidad'
import CancelarReserva from './pages/CancelarReserva'
import Encuesta from './pages/Encuesta'
import './App.css'

function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth()
  if (cargando) return <div className="loading">Cargando...</div>
  return usuario ? children : <Navigate to="/login" />
}

function RutaAdmin({ children }) {
  const { usuario, cargando } = useAuth()
  if (cargando) return <div className="loading">Cargando...</div>
  return usuario?.es_admin ? children : <Navigate to="/" />
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reservas" element={<Reservas />} />
          <Route path="/admin" element={<RutaAdmin><Admin /></RutaAdmin>} />
          <Route path="/admin/carta" element={<RutaAdmin><AdminCarta /></RutaAdmin>} />
          <Route path="/admin/encuestas" element={<RutaAdmin><AdminEncuestas /></RutaAdmin>} />
          <Route path="/admin/ajustes" element={<RutaAdmin><AdminAjustes /></RutaAdmin>} />
          <Route path="/carta" element={<Carta />} />
          <Route path="/alergenos" element={<Alergenos />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/cancelar/:token" element={<CancelarReserva />} />
          <Route path="/encuesta/:token" element={<Encuesta />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
